import Vue from 'vue'
import Vuex from 'vuex'
import { api } from './api.module'
import { loading } from './loading.module'
import { unloading } from './unloading.module'
import { documentTypes } from './documentTypes.module'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        info: '',
    },
    mutations: {
        SET_INFO(state, info) {
            state.info = info
        }
    },
    actions: {
        setEmptyInfo({ commit }, payload) {
            commit('SET_INFO', payload)
        }
    },
    getters: {
        info: (state) => {
            return state.info
        }
    },
    modules: {
        api,
        loading,
        unloading,
        documentTypes
    }
})
